import React, { useState, useEffect } from "react";
import "./Styles.css";
import { FaWhatsapp } from "react-icons/fa";

export default function Header() {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${h}h ${m}m ${s}s`;
  };

  return (
    <header className="header-clean">
      <h1>
        Manutenção de Computadores em <span className="break-mobile">Pilar do Sul</span>
      </h1>
      <p>Formatação, manutenção, upgrade e suporte técnico especializado em PCs e notebooks.</p>
      
      <div className="countdown-section">
        <div className="countdown-label">Promoção Exclusiva para Formatação</div>
        <div className="countdown-offer">R$ 100,00</div>
        <div className="countdown-timer-label">Oferta termina em</div>
        <div className="countdown-timer">{formatTime(timeLeft)}</div>

        {/* Botão logo abaixo do contador, sem container extra */}
        <a 
          href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."

          target="_blank" 
          rel="noopener noreferrer" 
          className="whatsapp-action"
        >
          <FaWhatsapp className="whatsapp-icon" /> Fale conosco
        </a>
      </div>
    </header>
  );
}
